import styled from 'styled-components';
import { theme } from '../../../../../../themes';

export const Container = styled.div<{image: string; disabled?: boolean}>`
  position: relative;
  padding: 32px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  width: 540px;
  height: 412px;

  display: flex;
  
  > div {
    :nth-of-type(1) {
      background: center / contain no-repeat url(${(p) => p.image});
      opacity: ${(p) => p.disabled ? 0.1 : 0.3};
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
    }
  
    :nth-of-type(2) {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 476px;
      z-index: 1;
      
      > div:last-of-type {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
      }
    }
  }
`;

export const SubParts = styled.div`
  display: flex;
  flex-direction: column;
  width: 476px;
  height: 100%;
`;

export const Checkboxes = styled.div<{height: number; oneColumn?: boolean; itemWidth?: number}>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-wrap: wrap;
  max-height: ${(p) => p.height}px;

  > div {
    ${(p) => p.oneColumn ? `max-width: 216px;` : ''}
    ${(p) => p.itemWidth ? `width: ${p.itemWidth}px;` : ''}
  }
`;

export const CheckboxesWheel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  
  > div {
    display: flex;
    justify-content: start;

    > div:nth-of-type(2) {
      margin-left: 16px;
    }

    > div:nth-of-type(3) {
      margin-left: auto;
    }
  }
`;

export const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
`;

export const PartSideSwitch = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  > span:first-of-type {
    font-family: ${theme.fonts.lato};
    font-size: 18px;
    font-weight: 500;
    line-height: 27px;
    letter-spacing: 0em;
    text-align: left;
  }
`;
